// Single-glyph icon component. Renders a Material Symbols Outlined glyph (the
// font is loaded by the single-menu theme via @import in styles.css) so
// every layout can pick a consistent iconography per design system.
//
// The font is loaded unconditionally in the embed bundle — small (~30KB
// variable-axis WOFF2) and reused across any layout that wants Symbols. If
// the font hasn't loaded yet the name shows as plain text — Material Symbols
// renders names like "refresh" as the actual glyph via the `liga` font
// feature; the moment the font lands, the name turns into the icon.

export interface IconProps {
  /** Material Symbols glyph name, e.g. "refresh", "delete", "view_in_ar". */
  name: string;
  size?: number;
  /** Filled style — bumps the FILL axis to 1. Off by default (Outlined look). */
  filled?: boolean;
  /** Title for screen readers + tooltip; aria-hidden if absent. */
  label?: string;
  className?: string;
}

export function Icon({ name, size = 20, filled, label, className }: IconProps) {
  const style: React.CSSProperties = {
    fontFamily: '"Material Symbols Outlined"',
    fontWeight: "normal",
    fontStyle: "normal",
    fontSize: size,
    lineHeight: 1,
    letterSpacing: "normal",
    textTransform: "none",
    display: "inline-block",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    direction: "ltr",
    fontFeatureSettings: "'liga'",
    WebkitFontSmoothing: "antialiased",
    fontVariationSettings: `'FILL' ${filled ? 1 : 0}, 'wght' 300, 'GRAD' 0, 'opsz' 24`,
    verticalAlign: "middle",
    userSelect: "none",
  };
  return (
    <span
      className={"material-symbols-outlined " + (className ?? "")}
      style={style}
      aria-hidden={label ? undefined : "true"}
      aria-label={label}
      title={label}
    >
      {name}
    </span>
  );
}
